
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
const Layout = require('@/layouts/RootFileLayout').RootFileLayout;
const meta = {
  "title": "Tradly Platform - Headless Commerce. API-FIRST. PaaS",
  "date": "2021-08-02"
};
const slug = 'tradly-platform-headless-commerce-api-first-paas';
const tableOfContents = [{
  "title": "Launch your platform apps at unbelievable speed 🚀",
  "slug": "launch-your-platform-apps-at-unbelievable-speed",
  "children": []
}, {
  "title": "Building blocks as API",
  "slug": "building-blocks-as-api",
  "children": []
}, {
  "title": "Multiple Catalogues",
  "slug": "multiple-catalogues",
  "children": []
}, {
  "title": "Cart, Booking",
  "slug": "cart-booking",
  "children": []
}, {
  "title": "Hybrid Listings, Account types",
  "slug": "hybrid-listings-account-types",
  "children": []
}, {
  "title": "Commissions",
  "slug": "commissions",
  "children": []
}, {
  "title": "Platform Infrastructure",
  "slug": "platform-infrastructure",
  "children": [{
    "title": "Headless Platform",
    "slug": "headless-platform",
    "children": []
  }, {
    "title": "API-First",
    "slug": "api-first",
    "children": []
  }, {
    "title": "Cloud Native",
    "slug": "cloud-native",
    "children": []
  }]
}, {
  "title": "Relationship centric",
  "slug": "relationship-centric",
  "children": [{
    "title": "Open Platform",
    "slug": "open-platform",
    "children": []
  }, {
    "title": "Social Commerce",
    "slug": "social-commerce",
    "children": []
  }]
}, {
  "title": "Why Tradly Platform?",
  "slug": "why-tradly-platform",
  "children": [{
    "title": "Pre-built Apps on Marketplace",
    "slug": "pre-built-apps-on-marketplace",
    "children": []
  }]
}, {
  "title": "Development Kits",
  "slug": "development-kits",
  "children": []
}, {
  "title": "Support is our priority",
  "slug": "support-is-our-priority",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = require('@/layouts/CustomContentsLayout').CustomContentsLayout
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <_Heading level={2} id={"launch-your-platform-apps-at-unbelievable-speed"} nextElement={{
      "type": "paragraph"
    }}>Launch your platform apps at unbelievable speed 🚀</_Heading>
    <p>{`Build any commerce, Platform apps using our modular blocks. Developer focused low code headless API and pre-built apps with no-code app configurations. `}<a parentName="p" {...{
        "href": "https://tradly.app/signup"
      }}>{`Start Building For Free`}</a></p>
    <p>{`✔️  HEADLESS PLATFORM`}<br parentName="p"></br>{`
`}{`✔️  API-FIRST`}<br parentName="p"></br>{`
`}{`✔️  MODULAR INFRASTRUCTURE`}</p>
    <_Heading level={2} id={"building-blocks-as-api"} nextElement={{
      "type": "paragraph"
    }}>Building blocks as API</_Heading>
    <p>{`Each block provides you with unique features. From commerce to community platforms. It’s modular in nature!`}</p>
    <_Heading level={2} id={"multiple-catalogues"} nextElement={{
      "type": "paragraph"
    }}>Multiple Catalogues</_Heading>
    <p>{`Configurable listing style for different business models and pricing rules`}</p>
    <_Heading level={2} id={"cart-booking"} nextElement={{
      "type": "paragraph"
    }}>Cart, Booking</_Heading>
    <p>{`Allow your customers to purchase product, book service, buy subscription, etc`}</p>
    <_Heading level={2} id={"hybrid-listings-account-types"} nextElement={{
      "type": "paragraph"
    }}>Hybrid Listings, Account types</_Heading>
    <p>{`SuperApp level architecture with different listing types and account types`}</p>
    <_Heading level={2} id={"commissions"} nextElement={{
      "type": "paragraph"
    }}>Commissions</_Heading>
    <p>{`Automated marketplace commission deduction, wallet payout, Gated Subscription flow, Special Fees., etc`}</p>
    <_Heading level={2} id={"platform-infrastructure"} nextElement={{
      "type": "heading",
      "depth": 3
    }}>Platform Infrastructure</_Heading>
    <_Heading level={3} id={"headless-platform"} nextElement={{
      "type": "paragraph"
    }}>Headless Platform</_Heading>
    <p>{`Front end agnostic. Build any apps on top of Tradly API from mobile app to IoT Apps. Comes with Admin dashboard.`}</p>
    <_Heading level={3} id={"api-first"} nextElement={{
      "type": "paragraph"
    }}>API-First</_Heading>
    <p>{`Use what you need. Consume wherever you need.`}</p>
    <_Heading level={3} id={"cloud-native"} nextElement={{
      "type": "paragraph"
    }}>Cloud Native</_Heading>
    <p>{`Hosted. Maintained for you from security to elastic`}<br parentName="p"></br>{`
`}{`scaling and automatically updating.`}</p>
    <_Heading level={2} id={"relationship-centric"} nextElement={{
      "type": "heading",
      "depth": 3
    }}>Relationship centric</_Heading>
    <_Heading level={3} id={"open-platform"} nextElement={{
      "type": "paragraph"
    }}>Open Platform</_Heading>
    <p>{`Each block built with a platform business model in mind. Anything you built can be platformised instead of single sided usage.`}</p>
    <_Heading level={3} id={"social-commerce"} nextElement={{
      "type": "paragraph"
    }}>Social Commerce</_Heading>
    <p>{`Relationship than transaction. Our fundamental blocks  built with social features. So from the first you start to build a community around your platform.`}</p>
    <_Heading level={2} id={"why-tradly-platform"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Why Tradly Platform?</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Launch within 10days`}</li>
      <li parentName="ul">{`Not months to develop an app`}</li>
      <li parentName="ul">{`Pay 1/10`}</li>
      <li parentName="ul">{`Risk-free, monthly subscription plans`}</li>
      <li parentName="ul">{`No code & Low-code`}</li>
      <li parentName="ul">{`Pre-built apps with no code editor + Low code pre-built APIs`}</li>
    </ul>
    <_Heading level={3} id={"pre-built-apps-on-marketplace"} nextElement={{
      "type": "paragraph"
    }}>Pre-built Apps on Marketplace</_Heading>
    <p>{`Open-source starter apps, Marketplace, Crowdfunding, B2C/D2C Brand Apps, Recycle management, SaaS Appstore for your business to kickstart immediately.`}</p>
    <_Heading level={2} id={"development-kits"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": true
    }}>Development Kits</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://www.npmjs.com/package/tradly"
          }}>{`JS SDK`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://developer.tradly.app/"
          }}>{`API Reference`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://github.com/TRADLY-PLATFORM/Butterflies"
          }}>{`NextJs`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://github.com/TRADLY-PLATFORM/Wolverine"
          }}>{`React Native`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://github.com/TRADLY-PLATFORM/Hummingbirds"
          }}>{`ReactJs`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://github.com/TRADLY-PLATFORM/Kittiwake"
          }}>{`Flutter`}</a></p>
      </li>
    </ul>
    <p>{`Open source apps pre-built on Tradly API`}</p>
    <_Heading level={2} id={"support-is-our-priority"} nextElement={{
      "type": "paragraph"
    }}>Support is our priority</_Heading>
    <p>{`“When I decided to launch my Australian based business, I reached out to Tradly to assist me in developing a very specific model of marketplace app. The Tradly Team put together a completely customised app that was to my business’s unique specifications in a short timeframe, creating a fantastic customer experience every step of the way. I was, and continue to be, blown away by the way, that Tradly has streamlined the white label app process, making an app presence accessible to businesses of all sizes.” `}</p>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
